import { frontSideAppHooks } from '../../common/FrontSideAppHooks/frontSideAppHooksModel'
import { selectOptionsMaster } from '../../common/SelectOptionsMaster/SelectOptionsMasterModel'
import { textTemplates } from '../../common/TextTemplateService/textTemplates'
import { modelDefinitions } from '../../common/modelDefinitions/modelDefinitions'
import { virtualModelDefinitions } from '../../common/virtualModelDefinitions/virtualModelDefinitions'
import { appDefinitions } from '../../plugins/AppDefinitions/appDefinitions'
import { appDocumentPages } from '../../plugins/AppDocuments/models/appDocumentPages'
import { core_composable_component_definitions } from '../../plugins/ComposableComponentBuilder/models/core_composable_component_definitions'
import { directus_permissions } from '../../plugins/Permissions/ModelDirectusPermissions'
import { record_workflow_definitions } from '../../plugins/RecordWorkflow/models/RecordWorkflowDefinition'
import { record_workflow_thread_item_related_users } from '../../plugins/RecordWorkflow/models/RecordWorkflowThreadItemRelatedUsers'
import { record_workflow_thread_items } from '../../plugins/RecordWorkflow/models/RecordWorkflowThreadItems'
import { record_workflow_threads } from '../../plugins/RecordWorkflow/models/RecordWorkflowThreads'
import { core_server_side_flows } from '../../plugins/ServerSideFlowsAndNodesDefinitions/models/core_server_side_flows'
import { serverSideAppHooks } from '../../plugins/ServersideAppHooks/models/serverSideAppHooksModel'
import { core_user_group_definitions } from '../../plugins/UserGroupDefinitions/models/core_user_group_definitions'
import { core_user_meta } from '../../plugins/UserMetaDataService/models/core_user_meta'
import { coreUserNotificationModels } from '../../plugins/UserNotifications/models/coreUserNotificationModels'
import { userOrgGroupsManagerModels } from '../../plugins/UserOrgGroupsManager/models'
import { anotherDataSourceModels } from '../../server/AnotherDataSourcesHandler/defineFromUI/anotherDataSourceModels'
import { userPasswordResetSecrets } from '../../server/DirectusUsersPasswordReset/userPasswordResetSecrets'
import { ModelDef } from '../../types'
import { dataExportSettings } from '../DataExportSettings/ModelDataExportSettings'
import { dataImportSettings } from '../DataImportSettings/ModelDataImportSettings'
import { directus_activity } from '../DirectusActivity/model_directus_activity'
import { files } from '../FileManager/ModelFiles'
import { user_roles } from '../UserRoles/user_roles'
import { directus_roles } from '../Users/directus_roles'
import { directus_users } from '../Users/directus_users'

export const coreDefaultModels: {
  [key: string]: ModelDef | Promise<ModelDef>
} = {
  dataImportSettings,
  dataExportSettings,
  selectOptionsMaster,
  modelDefinitions,
  virtualModelDefinitions,
  serverSideAppHooks,
  frontSideAppHooks,
  appDefinitions,
  textTemplates,
  user_roles,
  directus_users,
  directus_roles,
  files,
  userPasswordResetSecrets,
  directus_activity,
  directus_permissions,
  appDocumentPages,
  ...userOrgGroupsManagerModels,
  ...anotherDataSourceModels,
  // ...coreMessageSenderModels,
  ...coreUserNotificationModels,
  core_composable_component_definitions,
  core_user_group_definitions,
  record_workflow_definitions,
  record_workflow_threads,
  record_workflow_thread_items,
  record_workflow_thread_item_related_users,
  core_server_side_flows,
  core_user_meta,
  // core_front_model_permission_config,
}

/**
 * Master seed として, 一般的に言って同期するべきModel名のリスト
 * ※ Model追加時には, 下記判断し追加
 */
export const masterSeedableCoreDefaultModelNames = {
  dataImportSettings: {},
  dataExportSettings: {},
  selectOptionsMaster: {},
  modelDefinitions: {},
  virtualModelDefinitions: {},
  serverSideAppHooks: {},
  frontSideAppHooks: {},
  appDefinitions: {},
  textTemplates: {},
  user_roles: {},
  core_user_group_definitions: {},
  // core_front_model_permission_config: {},
  // directus_roles: {},
  // files: {},
  // notifications: {},
  // ganttDefinitions: {},
  // userPasswordResetSecrets: {},
  // directus_activity: {},
  // directus_permissions: {},
  // positions: {},
  organizations: {},
  // userGroups: {},
  // junctionUsersAndGroups: {},
  // junctionUsersAndOrgsAndPositions: {},
  appDocumentPages: {},
  core_another_data_source_dialects: {},
  core_another_data_source_connection_definitions: {},
  core_composable_component_definitions: {},
  record_workflow_definitions: {},
  core_server_side_flows: {},
}
